/**
 * X60 Pro Ultra – page-only video playback (swiper slides + common-media-video).
 * Plays every slide video while the swiper section is in view (muted).
 */
(function ($) {
  if (!$) return;

  var MEDIA_ROOT = '.main-content .common-media-video';

  function isX60SwiperSection(sectionEl) {
    return $(sectionEl).closest('[class*="x60-puc-swiper"]').length > 0;
  }

  function getX60SwiperSections() {
    return $('.main-content .new-common-product-swiper-section').filter(function () {
      return isX60SwiperSection(this);
    });
  }

  function getVisibleVideo($scope) {
    var $videos = $scope.find('video');
    if (!$videos.length) return null;
    var first = $videos[0];
    if (first.classList.contains('m-video') || first.classList.contains('pc-video')) {
      return ($(window).width() <= 820 ? $videos.filter('.m-video')[0] : $videos.filter('.pc-video')[0]) || $videos[0];
    }
    return $videos[0];
  }

  function isSectionInView(sectionEl) {
    if (!sectionEl) return false;
    var rect = sectionEl.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (rect.bottom <= 0 || rect.top >= vh) return false;

    var id = sectionEl.id;
    if (id && typeof isViewPort === 'function' && isViewPort('#' + id)) {
      return true;
    }

    var visibleHeight = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
    return visibleHeight > Math.min(rect.height * 0.15, vh * 0.12);
  }

  function excludeFromGlobalMonitor() {
    $(MEDIA_ROOT + ' .common-section-container').addClass('no-detect-video');
    getX60SwiperSections().addClass('no-detect-video');
  }

  function updateMediaVideos() {
    $(MEDIA_ROOT + ' .common-media-video-item').each(function () {
      var id = $(this).attr('id');
      var inView = id && typeof isViewPort === 'function' && isViewPort('#' + id);
      var video = getVisibleVideo($(this));
      if (!video) return;
      if (inView && video.paused) {
        video.play().catch(function () {});
      } else if (!inView && !video.paused) {
        video.pause();
      }
    });
  }

  function pauseSwiperVideos($section) {
    $section.find('.new-common-product-swiper-container video').each(function () {
      this.pause();
    });
  }

  function playAllSwiperVideos($section) {
    $section.find('.new-common-product-swiper-container .swiper-slide').each(function () {
      var video = getVisibleVideo($(this));
      if (!video) return;
      video.muted = true;
      if (video.paused) {
        video.play().catch(function () {});
      }
    });
  }

  function updateSwiperSection(sectionEl) {
    var $section = $(sectionEl);
    if (!$section.length || !isX60SwiperSection(sectionEl)) return;

    if (!isSectionInView(sectionEl)) {
      pauseSwiperVideos($section);
      return;
    }

    playAllSwiperVideos($section);
  }

  function updateAllSwipers() {
    getX60SwiperSections().each(function () {
      updateSwiperSection(this);
    });
  }

  function bindSwiperContainer(el) {
    if (!el.swiper || el.dataset.x60VideoBound) return;
    el.dataset.x60VideoBound = '1';

    var section = el.closest('.new-common-product-swiper-section');
    if (!section) return;

    var events = 'slideChange slideChangeTransitionEnd transitionEnd';
    el.swiper.on(events, function () {
      updateSwiperSection(section);
    });
  }

  function bindSwiperContainers() {
    $('.main-content [class*="x60-puc-swiper"] .new-common-product-swiper-container').each(function () {
      bindSwiperContainer(this);
    });
  }

  function tick() {
    excludeFromGlobalMonitor();
    updateMediaVideos();
    updateAllSwipers();
    bindSwiperContainers();
  }

  $(function () {
    tick();

    $(window).on('scroll resize', tick);

    $(document).on('click', '.main-content [class*="x60-puc-swiper"] .item_featured-item', function () {
      var section = $(this).closest('.new-common-product-swiper-section')[0];
      window.setTimeout(function () {
        updateSwiperSection(section);
      }, 120);
    });

    $(document).on(
      'click',
      '.main-content [class*="x60-puc-swiper"] .swiper-button-next, .main-content [class*="x60-puc-swiper"] .swiper-button-prev',
      function () {
        var section = $(this).closest('.new-common-product-swiper-section')[0];
        window.setTimeout(function () {
          updateSwiperSection(section);
        }, 120);
      }
    );

    [400, 900, 1500, 2500].forEach(function (delay) {
      window.setTimeout(tick, delay);
    });
  });
})(window.jQuery);
